/***
 *
 *   SELECT STYLES
 *   Ported from ui-reference/src/components/ui/select.tsx (SelectTrigger).
 *
 *   The reference uses a Radix listbox; this is a native <select>, so the
 *   chevron is drawn by the wrapper's ::after rather than an Icon child.
 *
 **********/

const Style = {
    input: 'relative mb-4 space-y-1.5 last:mb-0',

    base: `relative flex h-10 w-full cursor-pointer items-center overflow-hidden rounded-md border border-input
    bg-surface text-sm text-text-primary shadow-sm transition-colors
    focus-within:ring-2 focus-within:ring-ring
    after:pointer-events-none after:absolute after:right-3 after:top-1/2 after:h-3 after:w-3 after:-translate-y-1/2
    after:bg-contain after:opacity-70 after:bg-[url('components/form/select/icons/ico-dropdown.svg')]`,

    /* `bg-surface`, not `bg-transparent`: Chrome derives the native option
       popup's own background from the control, and a transparent control gives a
       white popup regardless of `color-scheme: dark`. Visually identical here —
       the wrapper it sits in is bg-surface too. The row colours come from the
       global `option` rule in css/input.css. */
    select: 'relative w-full cursor-pointer appearance-none border-transparent bg-surface px-3 py-2 pr-9 outline-none',

    success: 'border-success',
    error: 'border-error',
    warning: 'border-warning',

    // The old implementation faked the border with a ::before overlay because
    // the real border lived on an inner element. The border is on the wrapper
    // now, so the state keys are plain colour swaps.
    errorWrapper: 'border-error',
    warningWrapper: 'border-warning',

    message: 'mb-0',
};

export default Style;
